import Vec2 from './Vec2'
import {Fachwerkgelenk} from './Gelenk'

export default class Stab{
    /**
     * Klasse für Stäbe
     * @param {*} list 
     * @param {*} StartKnoten 
     * @param {*} EndKnoten 
     * @param {*} Querschnitt 
     * @param {*} StartGelenk 
     * @param {*} EndGelenk 
     * @param {*} isFachwerkstab 
     */
    constructor(list, StartKnoten, EndKnoten, Querschnitt, StartGelenk, EndGelenk, isFachwerkstab, Stabteilungen){
        this.Knoten = [StartKnoten, EndKnoten]
        if (isFachwerkstab) {
            this.Gelenke = [Fachwerkgelenk,Fachwerkgelenk]
        } else {
            this.Gelenke = [StartGelenk || null, EndGelenk || null]
        }
        this.Freiheitsgrade = [new Array(3), new Array(3)]
        this.Querschnitt = Querschnitt || null
        this.cFachwerkstab = isFachwerkstab || false
        this.list = list || null
        this.d3Node = undefined
        this.Stabteilungen = Stabteilungen || 10

        // Notitz: evtl. noch eine Variable zum festlegen der Stabteilungen anlegen. So kann für jeden Stab einzeln festgelegt werden wie oft er Unterteilt werden soll für die Ergebnisausgabe.


    }
    get StartKnoten() { return this.Knoten[0] }
    get EndKnoten() { return this.Knoten[1] }
    get StartGelenk() { return this.Gelenke[0] }
    get EndGelenk() { return this.Gelenke[1] }
    get isFachwerkstab() { return this.cFachwerkstab}

    set StartKnoten(knoten) { this.Knoten[0] = knoten }
    set EndKnoten(knoten) { this.Knoten[1] = knoten }
    set StartGelenk(gelenk) { this.Gelenke[0] = gelenk }
    set EndGelenk(gelenk) { this.Gelenke[1] = gelenk }
    set isFachwerkstab(value) { 
        if(value){
            this.Gelenke = [Fachwerkgelenk,Fachwerkgelenk] 
            this.cFachwerkstab = true
            this.Stabteilungen = 2
        }
        else{
            this.Gelenke = [null, null]
            this.cFachwerkstab = false
            this.Stabteilungen = 10
        }
    }

    get number() {
        if(this.list) return this.list.indexOf(this)+1
        else return null
    }
    /** für Beschrifungen gibt den Stabnamen zurück */
    get name() { return 'Stab Nr.' + this.number}
    
    /** gibt den Vektor des Stabes zurück */
    get vector() {
        return new Vec2(this.EndKnoten.x-this.StartKnoten.x,this.EndKnoten.y-this.StartKnoten.y)
    }
    
    /** gibt den Mittelpunkt des Stabes in xy Koordinaten zurück */
    get center() {
        let nvek = this.StartKnoten.Vec2.clone()
        let dvek = this.vector.scale(0.5)
        return nvek.add(dvek)
    }

    /** gibt die Länge des Stabes zurück */
    get length() { return this.vector.length }
    
    /** gibt den Sinus der Stabneidung zurück */
    get tsin() { if (this.vector.length) return this.vector.y / this.vector.length }
    
    /** gibt den Cosinus der Stabneigung zurück */
    get tcos() { if (this.vector.length) return this.vector.x / this.vector.length }

    release_bindings(lastfälle){
        /**
         * Vor dem Löschen des Stabes müssen die Verknüpfungen zu dem Stab gelöscht werden.
         */
        if (this.StartKnoten) this.StartKnoten.delete_Stabverknüpfung(this)
        if (this.EndKnoten) this.EndKnoten.delete_Stabverknüpfung(this)
        if (this.Querschnitt) this.Querschnitt.delete_Stabverknüpfung(this)
        if (this.StartGelenk) this.StartGelenk.delete_Stabverknüpfung(this)
        if (this.EndGelenk) this.EndGelenk.delete_Stabverknüpfung(this)
        
        //Die Verknüpfung mit den Stablasten werden im übergeordneten Objekt StatikSystem gelöst
    }



    /**
     * @param {Lastfall} Lastfall Der zugehörige Lastfall
     * @param {Integer} Stabteilungen die Anzahl der Stabteilungen
     */
    Schnittkräfte(Lastfall, Stabteilungen){
        /** 
         * Es werden für den Stab die Schnittkräfte an den Stellen der Stabteilungen ermittelt.
         * Es wird mit Stabsteifigkeiten bezogen auf das globale Koordinatensystem gearbeitet. Alternativ könnte man auch die Knotenverschiebungen in das Stabkoordinatensystem transformieren und dann die lokale Steifigkeit des Elementes verwenden.
         * 
         * 1.Schritt: es werden die Kräfte am Stabanfang aus den berechneten Kontenverschiebungen ermittelt. Dazu wird die jeweilige Knotenverschiebung mit der zugehörigen Elementsteifigkeit multipliziert und aufsummiert.
         * 2.Schritt: es werden die reduzierten Stablasten (ersatz Knotenlasten) von den Kräften aus den Knotenverformungen abgezogen, da diese in echt ja keine Lasten auf den Knoten sind sondern erst über die Stablänge wirken.
         * 3.Schritt: die Kräfte am Stabanfang in das Stabkoordinatensystem transformieren und in das Array für die Schnittkräfte als jeweils ersten Eintrag ablegen.
         * 4.Schritt: die Schnittkräfte an den zwischenpunkten ermitteln und im Array ablegen
         * 5.Schritt: berechnung der Verformungen in eigener Funktion.
         * 6.Schritt: Rückgabe der Schnittgrößen und Verformungen an das Lastfall-Objekt. Die Ergebnisse werden nicht beim Stab sondern beim Lastfall gespeichert. Damit die ergebnisse dem zugehörigen Stab zugeordnet werden können wird im Ergebniss-Array eine referenz auf den Stab abgelegt.
         */

        let Schnittkräfte = {Stab: this, N: [], Q: [], M: [], W: []} // neues Array zum Abspeichern der Schnittgrößen erstellen. Durch die Referenz auf diesen Stab (this) können die Ergebnisse später im Lastfall abgespeichert werden und trotzem dem Stab eindeutig zugeordnet werden.
        
        //Knotenverformungen auslesen
        const _u1 = Lastfall.Ergebnisvektor[this.Freiheitsgrade[0][0]-1] // Verformung in x-Richtung am Startknoten
        const _u2 = Lastfall.Ergebnisvektor[this.Freiheitsgrade[1][0]-1] // Verformung in x-Richtung am Endknoten
        const _v1 = Lastfall.Ergebnisvektor[this.Freiheitsgrade[0][1]-1] // Verformung in y-Richtung am Startknoten
        const _v2 = Lastfall.Ergebnisvektor[this.Freiheitsgrade[1][1]-1] // Verformung in y-Richtung am Endknoten
        const _phi1 = Lastfall.Ergebnisvektor[this.Freiheitsgrade[0][2]-1] // Knotendrehung am Startknoten
        const _phi2 = Lastfall.Ergebnisvektor[this.Freiheitsgrade[1][2]-1] // Knotendrehung am Endknoten
        const _knotenverschiebungen = [ _u1, _v1, _phi1, _u2, _v2, _phi2]
        
        //Stabeigenschaften
        const dx = this.vector.x; const dy = this.vector.y
        const l = this.length
        const ts = this.tsin; const tc = this.tcos
        
        // U1: Kraft am Knotenanfang in globaler X-Richtung
        // V1: Kraft am Knotenanfang in globaler Z-Richtung
        // M1: Moment am Knotenanfang
        let U1=0; let V1=0; let M1=0

        // 1.Schritt: Kräfte aus Knotenverformungen
        // Zeile der Elementsteifigkeitsmatrix * Spalte der Verschiebungsgrößen aus Ergebnisvektor
        for (let i = 0; i < 6; i++){
            U1 = U1 + this.Elementsteifigkeit_global(1,i+1) * _knotenverschiebungen[i]
            V1 = V1 + this.Elementsteifigkeit_global(2,i+1) * _knotenverschiebungen[i]
            M1 = M1 + this.Elementsteifigkeit_global(3,i+1) * _knotenverschiebungen[i]
        }
        // 2.Schritt: reduzierte Stablasten abziehen
        let QP1 = 0; let QP2 = 0; let QP3 = 0;
        let p=[0,0,0,0]

        // es werden alle Stablasten des gewählten Lastfalls durchsucht. Da mehrere Stablasten auf einen Stab gesetz werden können müssen die Ersatzknotenlasten aufsummiert werden...
        Lastfall.Stablastliste.forEach(Stablast => {
            // es werden alle Stäbe auf die die jeweilige Stablast wirkt durchsucht...
            Stablast.Stabliste.forEach(curStab=>{
                // alle Stäbe die nicht dieser (this) Stab sind werden ignoriert...
                if (curStab === this) {
                    // Ersatzknotenlasten der Stablast ermitteln (abhängig von Stabneigung und Stablänge)
                    // Die Prüfung, ob die Last lokal oder global und ob sie auf Stablänge oder Projektion bezogen ist erfolgt in der aufgerufenen Funktion.
                    QP1 += Stablast.ersKnotenlast(this, 0)
                    QP2 += Stablast.ersKnotenlast(this, 1)
                    QP3 += Stablast.ersKnotenlast(this, 2)

                    // Lastordinaten bezogen auf globales System ermitteln, wird für den nächsten Schritt benötigt um die Zwischenwerte an den Stabteilungen zu ermitteln.
                    const curp = Stablast.globalWerte(this) 
                    for (let i = 0; i<4; i++){
                        p[i] += curp[i]
                    }
                }
            })
        });
            U1 = U1 - QP1
            V1 = V1 - QP2
            M1 = M1 - QP3

        // 3.Schritt: globale Kräfte auf Stabkoordinatensystem transformieren und in das Schnittkraft Array eintragen. Falls ein Wert vom Betrag sehr klein ist wird er auf 0 gesetzt.
            const Na = -U1*tc+V1*ts
            const Qa = -U1*ts-V1*tc
            const Ma = M1 
            Schnittkräfte.N.push(Math.abs(Na) < 1e-5 ? 0 : Na)
            Schnittkräfte.Q.push(Math.abs(Qa) < 1e-5 ? 0 : Qa)
            Schnittkräfte.M.push(Math.abs(Ma) < 1e-5 ? 0 : Ma)

        // 4.Schritt: die Schnittkräfte an den zwischenpunkten ermitteln und im Array ablegen. Falls ein Wert vom Betrag sehr klein ist wird er auf 0 gesetzt.
        for (let i = 1; i <= Stabteilungen; i++ ){
            const x = i*l/Stabteilungen
            const a = x / l
            const xG = Math.abs(x*tc)
            const xY = Math.abs(x*ts)

            const py = p[2]+(p[3]-p[2])*a
            const px = p[0]+(p[1]-p[0])*a
            const Nx = Na + 0.5*(py+p[2])*xG*dy/l - 0.5*(px+p[0])*xY*dx/l
            const Qx = Qa - 0.5*(py+p[2])*xG*dx/l - 0.5*(px+p[0])*xY*dy/l
            const Mx = Ma + Qa*x-(py+2*p[2])*Math.pow(xG,2)/6*Math.sign(dx) - (px+2*p[0])*Math.pow(xY,2)/6*Math.sign(dy)
            Schnittkräfte.N.push(Math.abs(Nx) < 1e-5 ? 0 : Nx)
            Schnittkräfte.Q.push(Math.abs(Qx) < 1e-5 ? 0 : Qx)
            Schnittkräfte.M.push(Math.abs(Mx) < 1e-5 ? 0 : Mx)
        }

        // 5.Schritt: Verformungen werden in einer eigenen Funktion berechnet und in das Ergebnis-Array zurück übergeben.
        Schnittkräfte.W = this.Verformung(Lastfall, Stabteilungen, p)
        //console.log(Schnittkräfte.W) //ausgabe der Verformungen


        Lastfall.Schnittkräfte.push(Schnittkräfte)
    }

    /**
     * @param {Lastfall} Lastfall Der zugehörige Lastfall
     * @param {Lastfall} Stabteilungen die Anzahl der Stabteilungen
     * @param {Array} p die Lastordinaten der Stablasten bezogen auf ein globales Koordinatensystem. Diese Werte werden in der Funktion Schnittkräfte aufbereitet
     */
    Verformung(Lastfall, Stabteilungen, p){
        /**
         * Es werden für den Stab die Verformungen an den Stellen der Stabteilungen ermittelt und zurückgegeben.
         * 
         * Schritt 1: 
         */
        // Stabeigenschaften 
        const l = this.length
        const ts = this.tsin; const tc = this.tcos

        // Belastung aus Stablast auf Stabkoordinatensystem transformieren
        const p1 = p[0]*ts+p[2]*tc
        const p2 = p[1]*ts+p[3]*tc


        // Knotenverformungen aus den Ergebnissen auslesen
        const _u1 = Lastfall.Ergebnisvektor[this.Freiheitsgrade[0][0]-1]
        const _u2 = Lastfall.Ergebnisvektor[this.Freiheitsgrade[1][0]-1]
        const _v1 = Lastfall.Ergebnisvektor[this.Freiheitsgrade[0][1]-1]
        const _v2 = Lastfall.Ergebnisvektor[this.Freiheitsgrade[1][1]-1]
        // phi1 und phi2 um die Verformung aus der Stablast reduzieren da die Verformung aus Stablast sonst doppelt eingerechnet wird. Die Ersatzknotenlasten werden für den beidseitig eingespannten Träger ermittelt, so dass 
        let _phi1_red = Lastfall.Ergebnisvektor[this.Freiheitsgrade[0][2]-1] - (p1/24+(p2-p1)*7/360)*Math.pow(l,3)/this.Querschnitt.EI
        let _phi2_red = Lastfall.Ergebnisvektor[this.Freiheitsgrade[1][2]-1] + (p1/24+(p2-p1)/45)*Math.pow(l,3)/this.Querschnitt.EI



        // Verformungen in das Stabkoodinatensystem transformieren
        const v1 = ts*_u1+tc*_v1
        const v2 = ts*_u2+tc*_v2
        const u1 = tc*_u1-ts*_v1
        const u2 = tc*_u2-ts*_v2



        let Verformungen = [[u1,v1]]
        let x = 0

        for (let i = 1; i <= Stabteilungen; i++ ){
            x = i*l/Stabteilungen
            const a = x / l
            const b = (l-x)/l

            // aus Knotenverschiebung
            let vx = (1 - 3*Math.pow(a,2) + 2*Math.pow(a,3)) * v1 + (3*Math.pow(a,2) - 2*Math.pow(a,3)) * v2 + (x-2*x*a+x*Math.pow(a,2))*_phi1_red + (-x*a+x*Math.pow(a,2))*_phi2_red

            // aus Streckenlast
            // let pa = (p[2]*dx+p[0]*dy)*Math.abs(dx)/l/l
            // let pe = (p[3]*dx+p[1]*dy)*Math.abs(dx)/l/l 

            vx += (p1*a*(7-10*Math.pow(a,2)+3*Math.pow(a,4))+p2*b*(7-10*Math.pow(b,2)+3*Math.pow(b,4)))*Math.pow(l,4)/360/this.Querschnitt.EI

            let ux = u1 + (u2-u1)*a
            Verformungen.push([ux,vx])
        }
        return Verformungen
    }

    /**
     * Elementsteifigkeitsmatrix 6x6 bezogen auf globales System:
     * 
     *  zum Verständniss ist eine Herleitung der Elementsteifigkeitsmatrix z.B. in Jürgen Dankert "Technische Mechanik" Kapitel 18.2.4 zu finden.
     * 
     * 
     *  Folgende Abkürzungen werden in der Matrix verwendet:
     *  c=cos(Stabneigung)
     *  s=sin(Stabneigung) 
     *  β=(A*l²/I) 
     *        ┌                                                               ┐     ┌     ┐   ┌    ┐
     *        |   12s²+βc²  | (β-12)sc |-6ls  |-12s²-βc²  |-(β-12)sc  |-6ls   |     | u1  |   | U1 |
     *        |   (β-12)sc  | 12c²+βs² | 6lc  |-(β-12)sc  |-12c²-βs²  | 6lc   |     | v1  |   | V1 |
     *  EI/l³ |  -6ls       | 6lc      | 4l²  | 6ls       |-6lc       | 2l²   |  x  | p1  | = | M1 |
     *        |  -12s²-βc²  |-(β-12)sc | 6ls  | 12s²+βc²  | (β-12)sc  | 6ls   |     | u2  |   | U2 |
     *        |  -(β-12)sc  |-12c²-βs² |-6lc  | (β-12)sc  | 12c²+βs²  |-6lc   |     | v2  |   | V2 |
     *        |  -6ls       | 6lc      | 2l²  | 6ls       |-6lc       | 4l²   |     | p2  |   | M2 |
     *        └                                                               ┘     └     ┘   └    ┘
     * 
     *  Da die Elementmatrix an der Hauptdiagonalen gespiegelt ist können gibt es nur 18 Fälle. Es werden z.B. Position [1,1] gleich wie [4,4] berechnet.
     * 
     * @param {Integer} row 
     * @param {Interger} col 
     */
    Elementsteifigkeit_global(row, col){
        const l = this.length
        if (l) {
            const ts = this.tsin; const tc = this.tcos
            const EA_l = this.Querschnitt.EA / l; const EI_l = this.Querschnitt.EI / l
            let Wert = 0
            switch (true){
                case (row == 1 && col == 1) || (row == 4 && col == 4):
                    Wert = EA_l * Math.pow(tc,2) + 12 * EI_l / Math.pow(l,2) * Math.pow(ts,2) 
                break
                case (row == 1 && col == 2) || (row == 2 && col == 1):
                    Wert = -EA_l * tc * ts + 12 * EI_l / Math.pow(l,2) * tc * ts
                break
                case (row == 1 && col == 3) || (row == 3 && col == 1):
                    Wert =  6 * EI_l / l * ts
                break
                case (row == 1 && col == 4) || (row == 4 && col == 1):
                    Wert =  -(EA_l * Math.pow(tc,2) + 12 * EI_l / Math.pow(l,2) * Math.pow(ts,2))
                break
                case (row == 1 && col == 5) || (row == 5 && col == 1):
                    Wert =  -(-EA_l * tc * ts + 12 * EI_l / Math.pow(l,2) * tc * ts)
                break
                case (row == 1 && col == 6) || (row == 6 && col == 1):
                    Wert =  6 * EI_l / l * ts
                break
                case (row == 2 && col == 2) || (row == 5 && col == 5):
                    Wert =  EA_l * Math.pow(ts,2) + 12 * EI_l / Math.pow(l,2) * Math.pow(tc,2)
                break
                case (row == 2 && col == 3) || (row == 3 && col == 2):
                    Wert =  6 * EI_l / l * tc
                break
                case (row == 2 && col == 4) || (row == 4 && col == 2):
                    Wert =  -(-EA_l * tc * ts + 12 * EI_l / Math.pow(l,2) * tc * ts)
                break
                case (row == 2 && col == 5) || (row == 5 && col == 2):
                    Wert =  -(EA_l * Math.pow(ts,2) + 12 * EI_l / Math.pow(l,2) * Math.pow(tc,2))
                break
                case (row == 2 && col == 6) || (row == 6 && col == 2):
                    Wert =  6 * EI_l / l * tc
                break
                case (row == 3 && col == 3) || (row == 6 && col == 6):
                    Wert =  4 * EI_l
                break
                case (row == 3 && col == 4) || (row == 4 && col == 3):
                    Wert =  -(6 * EI_l / l * ts)
                break
                case (row == 3 && col == 5) || (row == 5 && col == 3):
                    Wert =  -(6 * EI_l / l * tc)
                break
                case (row == 3 && col == 6) || (row == 6 && col == 3):
                    Wert =  2 * EI_l
                break
                case (row == 4 && col == 5) || (row == 5 && col == 4):
                    Wert =  -EA_l * tc * ts + 12 * EI_l / Math.pow(l,2) * tc * ts
                break
                case (row == 4 && col == 6) || (row == 6 && col == 4):
                    Wert =  -(6 * EI_l / l * ts)
                break
                case (row == 5 && col == 6) || (row == 6 && col == 5):
                    Wert =  -(6 * EI_l / l * tc)
            }
            if (this.StartGelenk){

                // -6ls*u1 + 6lc*v1 + 4l²*p1 + 6ls*u2 + -6lc*v2 + 2l²*p2 = | M1 |

                //hier sind noch ergänzungen für gefederte Kopplungen zu ergänzen
            }
            if (this.EndGelenk){
                //hier sind noch ergänzungen für gefederte Kopplungen zu ergänzen
            }
            return Wert
        } 
    }
}
